var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLocation2 = function SvgLocation2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3238195,48.499167 C41.719934,41.0850897 46,34.8433268 46,29.5 C46,21.5097243 39.7506647,15 32,15 C24.2493353,15 18,21.5097243 18,29.5 C18,34.8433268 22.280066,41.0850897 30.6761805,48.499167 L32,49.6681483 L33.3238195,48.499167 Z M22,29.5 C22,23.6831569 26.4958307,19 32,19 C37.5041693,19 42,23.6831569 42,29.5 C42,33.1302692 38.7120969,38.1424408 32,44.3089355 C25.2879031,38.1424408 22,33.1302692 22,29.5 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 4
  }))));
};
export default SvgLocation2;